import { useRouter } from "next/router";
import Link from 'next/link'

const links = [
  {path: "/muses", title: "BEYOND"},
  {path: "/muses/bts", title: "Behind the scenes"},
  {path: "/muses/interviews", title: "Interviews"}
];

const MuseNav = () => {
  const router = useRouter();

  return (
    <ul className="font-soehne-leight text-olive uppercase flex text-center gap-5 justify-center mt-5">
      {links.map((link) => (<li key={link.title} className={router.asPath === link.path ? "underline" : ""}><Link href={link.path}>{link.title}</Link></li>))}
    </ul>
  )
};
export default MuseNav;
